import AddReview from './add-review-layout';

Vue.component(AddReview.name, AddReview);
